import React, { useEffect, useState } from "react";
import { Row, Col, Button, Divider } from "antd";
import styled from "styled-components";
import { FaPlusCircle } from "react-icons/all";
import { UserAction } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineSearch } from "react-icons/all";
import CustomModal from "../../components/modals/customModal";
import TextInput from "../../components/input/TextInput";
import { formatToNumber } from "../../config/utils";
import { MdLocationPin, HiPhone, MdEmail } from "react-icons/all";

import Select, { components } from "react-select";
import LoaderGif from "../../assets/images/ie_loader.gif";
import { EMAIL_REGX } from "../../config/variables";
import "./index.css";
import { LocalActivity } from "@mui/icons-material";

import PlacesInput from "../../components/placeInput";
const CheckoutContainer = styled.div`
  min-height: 200px;
  border: 1px solid #edeff0;
  margin-top: 1rem;
  margin-left: 1.5rem;
  padding: 12px;
`;
function CheckoutCard({
  heading,
  onChangeAddress,
  type,
  onSubmitAddress,
  error,
  mainHeading,
  showBillingAddressField,
  showShippingAddressField
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(UserAction.getAddressReq());
  }, []);
  const address = useSelector((store) => store.UserReducer.addresses);
  const addressOption = address.map((item) => {
    return { label: `${item.name} | ${item.address}`, value: item.id };
  });
  console.log("addresssssss", addressOption);
  const [addressPayload, setAddressPayload] = useState({
    email: "",
    // zipcode: "",
    name: "",
    phone: "",
    address: "",
    contact_person: "",
    geocode: [],
  });
  const [zipcode, setZipCode] = useState("");

  console.log("addPay", addressPayload);

  const [addressValue, setAddressValue] = useState("");
  const [customError, setCustomError] = useState({
    emailError: "",
    zipcodeError: "",
    phoneError: "",
    nameError: "",
    addressError: "",
    contactPersonError: ""
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const [location, setLocation] = useState([]);
  const [isOpenAddress, setIsOpenModal] = useState(false);



  // const onChangeLocation = (e) => {
  //   const obj = {
  //     address: e,
  //     key: "AIzaSyDZ0ipZ-kLwiyOvIUINdg3X0Z-JOyl8V_k",
  //   };
  //   const qureyParams = new URLSearchParams(obj).toString();
  //   fetch(`https://maps.googleapis.com/maps/api/geocode/json?${qureyParams}`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setLocation(data.results);
  //     });
  //   setCustomError({
  //     ...customError,
  //     addressError: ""

  //   })
  // };

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <AiOutlineSearch />
        </components.DropdownIndicator>
      )
    );
  };

  const onHandleChanged = (e) => {
    console.log(e.target.name, "E===>");
    setAddressPayload({
      ...addressPayload,
      [e.target.name]: e.target.value,
    });
    setCustomError({
      ...customError,
      [`${e.target.name}Error`]: "",
    });
  };
  const onSubmit = () => {
    const { address, phone, email, name, contact_person } = addressPayload;
    const addressObj = {
      zipcode: zipcode,
      address: addressValue,
      phone: phone,
      email: email,
      name: name,
      contact_person: contact_person
    }
    console.log(addressPayload, "SADJHASKJDHASJKD")
    const err = { ...customError };
    if (
      !zipcode.trim().length ||
      // !contact_person.length ||
      !addressValue.trim().length ||
      !phone.trim().length ||
      !EMAIL_REGX.test(email) ||
      !name.trim().length
    ) {
      if (!zipcode.trim().length) {
        err.zipcodeError = "Zipcode is required.";
      }
      if (!name.trim().length) {
        err.nameError = "Location name is required.";
      }
      if (!addressValue.trim().length) {
        err.addressError = "Location address is required.";
      }
      if (!phone.trim().length) {
        err.phoneError = "Phone is required.";
      }
      if (!EMAIL_REGX.test(email)) {
        err.emailError = "Email is required and format should be john@doe.com";
      }
      // if (!contact_person?.trim().length) {
      //   err.contactPersonError = "Contact Person is required.";
      // }
      setCustomError(err);
      return;
    }
    dispatch(
      UserAction.createAddressReq(addressObj, () => {
        setIsOpenModal(false)
        setZipCode("")
      }, {
        per_page: 10000,

      })
    );
  };

  const checkZipCode = (val, location) => {
    // const ab = { ...addressPayload, ...location };
    console.log('locccaru==>', location)

    val.forEach((item) => {
      for (let address of item.address_components) {
        if (address.types.includes("postal_code")) {
          // this.state.addressPayload.zipcode=address.long_name
          setZipCode(address.long_name);
          // setAddressPayload(ab);
          setCustomError({ ...customError, zipcodeError: "" });
          return;
          // this.contractorAddress.zipcode = address.long_name;
        } else {
          // debugger
          // if (addressValue == "") {
          //   debugger
          //   setZipCode("");
          // }

          // setAddressPayload(ab);

          setCustomError({ ...customError, zipcodeError: "" });
        }

      }
      // if (!addressValue || ) {
      //   debugger
      //   setZipCode("");
      // }
      // if (!location.address || !addressPayload.address) {
      //   setZipCode("");
      // }
    });

  };
  // console.log("zipCodem", zipCode);
  console.log("zipCodemadd", addressPayload.address);

  console.log("address main", addressValue);


  const { phone, email, name, contact_person } = addressPayload;
  const { zipcodeError, addressError, phoneError, emailError, nameError, contactPersonError } =
    customError;
  const isLoader = useSelector((store) => store.UserReducer?.isPostAddress);
  // console.log("addresPayloadd=>", addressPayload);
  console.log("addresPayloadd=>", showShippingAddressField);

  return (
    <Row>
      <Col
        xl={14}
        lg={14}
        md={14}
        xs={24}
        sm={14}
        xxl={24}
        style={{ marginTop: "2.2rem" }}
      >
        <Row justify="center">
          <Col span={22}>
            <h2 className="text-left checkout-heading">{mainHeading}</h2>
          </Col>
        </Row>
        <CheckoutContainer>
          <Row align="middle" justify="space-between">
            <Col span={12} className="text-left">
              <h2>{heading}</h2>
            </Col>
            <Col span={12} className="text-right">
              <Row
                align="middle"
                justify="space-between"
                onClick={() => setIsOpenModal(true)}
              >
                <Col span={24}>
                  <span style={{ padding: "2px" }} className="pointer-cursor">
                    <FaPlusCircle color="rgb(38, 166, 154)" size={15} />
                  </span>
                  <span
                    className="address-styling pointer-cursor"
                    style={{ color: "rgb(38, 166, 154)", padding: "5px" }}
                    onClick={() => {
                      setAddressPayload({
                        email: "",
                        // zipcode: "",
                        name: "",
                        contact_person: "",
                        phone: "",
                        address: "",
                        geocode: [],
                      });
                      setCustomError({
                        emailError: "",
                        zipcodeError: "",
                        phoneError: "",
                        nameError: "",
                        addressError: "",
                        contactPersonError: ""
                      });
                      setAddressValue("");
                      setZipCode("");

                    }}
                  >
                    Add a new address
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="center">
            <Col span={24} style={{ marginTop: "0.8rem" }}>
              <Select
                className="css-1n7v3ny-option"
                placeholder={`Select ${heading}`}
                value={heading == "Billing Address" ? showBillingAddressField : showShippingAddressField}
                // defaultValue={heading == "Billing Address" ? showBillingAddressField : showShippingAddressField}
                name="geocode"
                onChange={(e) => {
                  onChangeAddress(type, e.value, e);
                }}
                options={addressOption}
              />
            </Col>
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <p className="text-right danger-color ">{error}</p>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="end" style={{ marginTop: "1rem" }}>
            <Col span={10} className="text-right">
              {isLoader ? (
                <img src={LoaderGif} height={60} width={60} />
              ) : (
                <Button
                  style={{
                    backgroundColor: "orange",
                    color: "#fff",
                    width: "100%",
                  }}
                  onClick={() => onSubmitAddress()}
                >
                  CONTINUE
                </Button>
              )}
            </Col>
          </Row>
          <CustomModal
            className="address-modal"
            visible={isOpenAddress}
            onCancelModal={() => setIsOpenModal(false)}
            footer={[
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => onSubmit()}
              >
                Save
              </Button>,
            ]}
          >
            <Col span={24}>
              <h5 className="text-center st-primary">
                {isUpdate ? "Edit Address" : "Add Address"}
              </h5>
              <Divider />
            </Col>
            <Col span={24} className="pointer-cursor">
              <Row justify="center">
                <Col span={22}>
                  <form>
                    <Row justify="center" gutter={[5, 0]}>

                      <Col span={24} >
                        <TextInput
                          label="Location Name/Label"
                          name="name"
                          onChange={onHandleChanged}
                          value={name}
                          required
                          Icon={MdLocationPin}
                          color="lightgrey"
                          style={{ border: "none", fontSize: "95%" }}
                        />
                        <Row>
                          <Col
                            span={24}
                            className="text-right"
                            style={{ marginTop: "10px" }}
                          >
                            {" "}
                            <span
                              className="danger-color"
                              style={{ fontSize: "80%" }}
                            >
                              {nameError && nameError}
                            </span>
                          </Col>
                        </Row>
                      </Col>


                      <Col xl={24}>
                        <TextInput
                          label="Contact Person Name"
                          name="contact_person"
                          onChange={onHandleChanged}
                          value={contact_person}
                          Icon={MdEmail}
                          color="grey"
                          style={{ border: "none", fontSize: "95%" }}
                        />
                        <Row>
                          <Col
                            span={24}
                            className="text-right"
                            style={{ marginTop: "10px" }}
                          >
                            {" "}
                            <span
                              className="danger-color"
                              style={{ fontSize: "80%" }}
                            >
                              {contactPersonError && contactPersonError}
                            </span>
                          </Col>
                        </Row>
                      </Col>{" "}

                      <Col span={24} className="select-categories">
                        <span
                          style={{
                            color: "#26a69a",
                            marginRight: "10px",
                            fontSize: "16px",
                          }}
                        >
                          Location Address{" "}
                          <span className="color-orange">*</span>{" "}
                        </span>
                        <PlacesInput
                          className="userSelect"
                          value={addressValue}
                          onChange={(e) => {

                            if (e.target.value == "") {
                              setZipCode("")
                              setAddressValue("")
                            }
                            else {
                              setAddressValue(e.target.value)
                            }

                          }}
                          onSetValue={(val) => {

                            console.log('valueee==>', val)
                            const location = { ...addressPayload };
                            location.address = val.formatted_address;
                            location.geocode = [val];

                            setCustomError({
                              addressError: "",
                            });
                            console.log('location==>', location)
                            setAddressValue(val?.formatted_address);
                            checkZipCode([val], location);
                          }}
                        />
                        {/* <Select
                          className="userSelect"
                          placeholder=""
                          name="geocode"
                          components={{ DropdownIndicator }}
                          value={addressValue}
                          onChange={(e) => {
                            console.log("e===>", e.value)
                            setAddressPayload({
                              ...addressPayload,
                              address: e.label,
                              geoCode: [e.value],
                            });
                            setCustomError({
                              addressError: ""
                            })
                            setAddressValue(e)
                          }}
                          onKeyDown={(e) => onChangeLocation(e.target.value)}
                          options={classoptions}
                        /> */}
                        <Row>
                          <Col
                            span={24}
                            className="text-right"
                            style={{ marginTop: "10px" }}
                          >
                            {" "}
                            <span
                              className="danger-color"
                              style={{ fontSize: "80%" }}
                            >
                              {addressError && addressError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={24}>
                        <TextInput
                          label="Zip Code"
                          name="zipcode"
                          onChange={(e) => setZipCode(e.target.value)}
                          value={zipcode}
                          required
                          Icon={MdLocationPin}
                          color="lightgrey"
                          style={{ border: "none", fontSize: "95%" }}
                        />
                        <Row>
                          <Col
                            span={24}
                            className="text-right"
                            style={{ marginTop: "10px" }}
                          >
                            {" "}
                            <span
                              className="danger-color"
                              style={{ fontSize: "80%" }}
                            >
                              {zipcodeError && zipcodeError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={24}>
                        <TextInput
                          label="Phone"
                          name="phone"
                          onChange={onHandleChanged}
                          value={formatToNumber(phone)}
                          required
                          Icon={HiPhone}
                          color="grey"
                          maxLength={15}
                          style={{ border: "none", fontSize: "95%" }}
                        />
                        <Row>
                          <Col
                            span={24}
                            className="text-right"
                            style={{ marginTop: "10px" }}
                          >
                            {" "}
                            <span
                              className="danger-color"
                              style={{ fontSize: "80%" }}
                            >
                              {phoneError && phoneError}
                            </span>
                          </Col>
                        </Row>
                      </Col>{" "}
                      <Col xl={24}>
                        <TextInput
                          label="Email"
                          name="email"
                          onChange={onHandleChanged}
                          value={email}
                          required
                          Icon={MdEmail}
                          color="grey"
                          style={{ border: "none", fontSize: "95%" }}
                        />
                        <Row>
                          <Col
                            span={24}
                            className="text-right"
                            style={{ marginTop: "10px" }}
                          >
                            {" "}
                            <span
                              className="danger-color"
                              style={{ fontSize: "80%" }}
                            >
                              {emailError && emailError}
                            </span>
                          </Col>
                        </Row>
                      </Col>{" "}






                    </Row>
                  </form>{" "}
                </Col>
              </Row>
            </Col>
          </CustomModal>
          {/* <CustomModal
            className="address-modal"
            visible={isOpenAddress}
            onCancelModal={() => setIsOpenModal(false)}
            footer={[
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => onSubmit()}
              >
                Save
              </Button>
            ]}
          >
            <Col xl={24}>
              <h5 className="text-center st-primary">
                {isUpdate ? "Edit Address" : "Add Address"}
              </h5>
              <Divider />
            </Col>
            <Col xl={24} className="pointer-cursor">
              <Row justify="center">
                <Col xl={24}>
                  <form>
                    <Row justify="space-between" gutter={[5, 25]}>
                      <Col xl={24} className="select-categories">
                        <Select
                          className="userSelect"
                          placeholder="Location"
                          name="geocode"
                          value={addressValue}
                          components={{ DropdownIndicator }}
                          onChange={(e) => {
                            console.log("e===>", e.value)
                            setAddressPayload({
                              ...addressPayload,
                              address: e.label,
                              geoCode: [e.value],
                            });
                            setCustomError({
                              addressError: ""
                            })
                            setAddressValue(e)
                          }}
                          onKeyDown={(e) => onChangeLocation(e.target.value)}
                          options={classoptions}
                        />
                        <Row justify="end">
                          <Col className="text-right">
                            <span className="danger-color">
                              {addressError && addressError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={24}>
                        <TextInput
                          label="Zip Code"
                          name="zipcode"
                          onChange={onHandleChanged}
                          value={zipcode}
                          required
                          Icon={MdLocationPin}
                          color="lightgrey"
                        />
                        <Row justify="end">
                          <Col className="text-right">
                            <span className="danger-color text-right">
                              {zipcodeError && zipcodeError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={24}>
                        <TextInput
                          label="Phone"
                          name="phone"
                          onChange={onHandleChanged}
                          value={formatToNumber(phone)}
                          required
                          Icon={HiPhone}
                          color="grey"
                        />
                        <Row justify="end">
                          <Col className="text-right">
                            <span className="danger-color">
                              {phoneError && phoneError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={24}>
                        <TextInput
                          label="Email"
                          name="email"
                          onChange={onHandleChanged}
                          value={email}
                          required
                          Icon={MdEmail}
                          color="grey"
                        />
                        <Row justify="end">
                          <Col className="text-right">
                            <span className="danger-color">
                              {emailError && emailError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </form>
                </Col>
              </Row>
            </Col>
          </CustomModal> */}
        </CheckoutContainer>
      </Col>
    </Row>
  );
}
export default CheckoutCard;
